/** Formas sólidas y pelota, como en la marca de Rankealo. */
export function IconoNavegacion({ tipo }: { tipo: 'inicio' | 'cargar' | 'tabla' | 'perfil' | 'admin' }) {
  if (tipo === 'tabla') return (
    <svg viewBox="0 0 72 64" className="h-7 w-8" aria-hidden="true" focusable="false">
      <g fill="currentColor">
        <path d="M8 36 Q8 32 14 30 L19 29 Q23 28 23 32 V53 Q23 56 20 56 H11 Q8 56 8 53 Z" />
        <path d="M27 25 Q27 21 33 19 L38 18 Q42 17 42 21 V53 Q42 56 39 56 H30 Q27 56 27 53 Z" />
        <path d="M46 13 Q46 9 52 7 L57 6 Q61 5 61 9 V53 Q61 56 58 56 H49 Q46 56 46 53 Z" />
      </g>
      <circle cx="51" cy="43" r="14" fill="var(--color-texto)" stroke="var(--color-sobre-acento)" strokeWidth="2" />
      <g fill="none" stroke="var(--color-sobre-acento)" strokeWidth="2.3" strokeLinecap="round">
        <path d="M45 31 Q49 41 39 47" /><path d="M63 40 Q51 43 53 55" />
      </g>
    </svg>
  );
  return (
    <svg viewBox="0 0 32 32" className="h-7 w-8" aria-hidden="true" focusable="false">
      {tipo === 'inicio' ?
        <path fill="currentColor" d="M3 14 14 4a3 3 0 0 1 4 0l11 10a2 2 0 0 1-1.3 3.5H26V27a2 2 0 0 1-2 2h-5V19h-6v10H8a2 2 0 0 1-2-2v-9.5H4.3A2 2 0 0 1 3 14Z" />
        : tipo === 'cargar' ? <>
          <rect x="4" y="4" width="24" height="24" rx="5" fill="none" stroke="currentColor" strokeWidth="3" />
          <path d="M16 10v12M10 16h12" stroke="currentColor" strokeWidth="4" strokeLinecap="round" />
        </> : tipo === 'perfil' ? <>
          <circle cx="16" cy="10" r="6" fill="currentColor" />
          <path d="M5 29v-3a11 11 0 0 1 22 0v3H5Z" fill="currentColor" />
        </> : <>
          <circle cx="12" cy="10" r="5" fill="currentColor" />
          <circle cx="23" cy="12" r="4" fill="currentColor" opacity=".65" />
          <path d="M3 27v-4a9 9 0 0 1 18 0v4H3Z" fill="currentColor" />
          <path d="M23 19a7 7 0 0 1 7 7v1h-6v-4a12 12 0 0 0-.7-4Z" fill="currentColor" opacity=".65" />
        </>}
    </svg>
  );
}
